import axios from 'axios'

const apiBase = `http://f-edge.${window.brandProps.theme}.bora.systems`

export const fetchPorts = () => axios({ method: 'get', url: `${apiBase}/catalog/api/v1/catalog/PORTS` })
